import React, { useEffect, useState } from "react";
import { Pagination, Stack } from "@mui/material";
import SingleCard from "../SingleCard";
import styles from "./CardsContiner.module.css";

function CardsContainer({
    allTrips,
    setCurrentPage,
    currentPage,
    totalRecords,
    liveTrackingTrips,
    setSelectedTrip,
    selectedTrip,
}) {
    const [tripDetails, setTripDetails] = useState([]);

    useEffect(() => {
        if (!allTrips) return;

        const tripsData =
            allTrips.trips?.map((trip) => {
                const tripId = trip.id;

                const truck = allTrips.trucks?.find(
                    (t) => t.id === trip.relationships?.truck?.data?.id
                );

                const truckTypes = allTrips.truckTypes?.find(
                    (t) => t.id == trip.attributes?.truckTypeId
                );
                const truckType = truckTypes?.attributes?.alias || "N/A";
                const truckPlateNumber = truck?.attributes?.plateNumber || "N/A";

                const driver = allTrips.drivers?.find(
                    (d) => d.id === trip.relationships?.driver?.data?.id
                );
                const driverName = driver?.attributes?.name || "N/A";
                const driverNumber = driver?.attributes?.phoneNumber || "N/A";

                const tripStatus = trip.attributes?.status || "N/A";

                const tripPoints =
                    allTrips.tripPoints
                        // eslint-disable-next-line eqeqeq
                        ?.filter((point) => point.attributes?.tripId == trip.id)
                        ?.map(
                            (point) =>
                                point.attributes?.locationAttributes?.data?.attributes?.nameAr ||
                                point.attributes?.locationAttributes?.data?.attributes?.name ||
                                "N/A"
                        ) || [];

                const activeTripDetails = liveTrackingTrips.find(
                    (activeTrip) => activeTrip.tid === trip.id
                );

                return {
                    id: tripId,
                    truckType,
                    truckPlateNumber,
                    driverName,
                    driverNumber,
                    tripStatus,
                    tripPoints,
                    ...activeTripDetails,
                };
            }) || [];

        setTripDetails(tripsData);
    }, [allTrips, liveTrackingTrips]);

    const handlePageChange = (event, value) => {
        setCurrentPage(value);
    };

    return (
        <div className={styles.CardsContainer}>
            {tripDetails.length === 0 ? (
                <div className={styles.noTrips}>No active trips</div>
            ) : (
                <>
                    {tripDetails.map((item) => (
                        <SingleCard
                            key={item.id}
                            tripStatus={item.tripStatus}
                            tripPoints={item.tripPoints}
                            driverName={item.driverName}
                            driverNumber={item.driverNumber}
                            truckType={item.truckType}
                            truckPlateNumber={item?.truckPlateNumber}
                            tripId={item?.id}
                            setSelectedTrip={setSelectedTrip}
                            selectedTrip={selectedTrip}
                            trip={item}
                        />
                    ))}
                    <Stack
                        alignItems="center"
                        justifyContent="center"
                        spacing={2}
                    >
                        <Pagination
                            count={Math.ceil(totalRecords / 10)}
                            page={currentPage}
                            onChange={handlePageChange}
                            size="medium"
                        />
                    </Stack>
                </>
            )}
        </div>
    );
}

export default CardsContainer;
